var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_3555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.26676 6.68533C6.66353 6.84376 6.11868 7.30464 5.83652 7.89035C5.69544 8.188 5.68085 8.26002 5.68085 8.67289C5.68085 9.07617 5.69544 9.15778 5.8122 9.37382C6.33273 10.3484 7.82621 10.9965 10.4483 11.3854C12.2921 11.6638 13.3428 11.8847 14.199 12.1823C15.3033 12.5664 16.145 13.0801 16.6606 13.6946L16.8406 13.9106L17.5411 11.7839C17.9303 10.6124 18.2806 9.54185 18.3244 9.39782C18.48 8.86973 18.3876 8.1928 18.0957 7.70312C17.9109 7.39106 17.473 7.00699 17.1033 6.83416L16.7725 6.68053L15.2401 6.65172C14.3985 6.63252 12.3164 6.61812 10.6186 6.61812C8.06945 6.61332 7.48567 6.62772 7.26676 6.68533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62945 12.2111C6.68296 12.3647 7.04295 13.4833 7.43213 14.6979C7.82131 15.9125 8.19103 17.0119 8.25428 17.1464C8.51211 17.7033 9.18345 18.2026 9.83532 18.3226C10.2488 18.3994 13.9947 18.385 14.2914 18.3034C15.1331 18.0825 15.7411 17.42 15.999 16.4502C16.5 14.5299 14.8606 13.5121 10.1807 12.8496C8.6094 12.6239 7.59267 12.3839 6.8289 12.0526C6.68782 11.9902 6.56134 11.9374 6.55161 11.9374C6.54674 11.9374 6.5808 12.0622 6.62945 12.2111Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_3555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.7943,
    height: 11.8582,
    fill: "white",
    transform: "translate(5.68085 6.61719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeated);
export default __webpack_public_path__ + "static/media/seated.25816392.svg";
export { ForwardRef as ReactComponent };